<div class="dialog-container">
  <div mat-dialog-content class="prompt-content">
    <div class="prompt-wrapper">
      <div class="form-group">
        <label for="" class="form-label">{{data.textLabel}}</label>
        <input type="text" [(ngModel)]="data.textValue" class="form-control" [placeholder]=data.placeholder />
      </div>
      <div class="form-group">
        <label for="" class="form-label">{{data.colorLabel}}</label>
        <ng-select bindLabel="name" class="single-select" placeholder="" [(ngModel)]="data.colorValue"
          [searchable]="true" [clearable]="true" >
          @for (color of data.options; track color) {
          <ng-option [value]="color">
            <span class="color-option" [ngStyle]="{'background-color': color}"></span>
          </ng-option>
          }
        </ng-select>
      </div>
    </div>

  </div>
  <app-dialog-footer [dialogResult]="data" wrapperClass="setup-footer" />
</div>
